import BaseService from "./Base.Service";

/** Grupos confidenciais (só ADM). Os erros sobem para a tela, que mostra a msg do back. */
class ConfidentialGroupsService extends BaseService {
  constructor() {
    super("confidential-groups");
  }

  async listGroups() {
    const { data } = await this.conn.axios.get("/confidential-groups");
    return data;
  }

  async getGroup(id) {
    const { data } = await this.conn.axios.get(`/confidential-groups/${id}`);
    return data;
  }

  async createGroup(name) {
    const { data } = await this.conn.axios.post("/confidential-groups", { name });
    return data;
  }

  async renameGroup(id, name) {
    const { data } = await this.conn.axios.put(`/confidential-groups/${id}`, { name });
    return data;
  }

  async deleteGroup(id) {
    const { data } = await this.conn.axios.delete(`/confidential-groups/${id}`);
    return data;
  }

  async addMembers(id, userIds) {
    const { data } = await this.conn.axios.post(`/confidential-groups/${id}/members`, { user_ids: userIds });
    return data;
  }

  async removeMember(id, userId) {
    const { data } = await this.conn.axios.delete(`/confidential-groups/${id}/members/${userId}`);
    return data;
  }
}

export default ConfidentialGroupsService;
